<script>
	let name = 'FYRING';
	export let view = 0;
	import { language } from './stores.js';
	function openHome() {
		console.log("home")
	  window.open("https://www.fyring.se","_self");
	}
</script>




<div id="textblock">
	<div id="logoblock" on:click={openHome}>
	<h1 on:click={openHome}>{name}</h1>
	<!-- <h1>{name}</h1> -->
	</div>
	<div id="listblock">



		<button
						class="{view === 0 ? 'selected' : ''}"
						on:click={() => view = 0}>
						{#if $language == 0}hem
						{:else}home
						{/if}
		</button>

			<button
						class="{view === 1 ? 'selected' : ''}"
						on:click={() => view = 1}>
						{#if $language == 0}snaps
						{:else}snaps
						{/if}
		</button>
		<button
					class="{view === 3 ? 'selected' : ''}"
					on:click={() => view = 3}>
					{#if $language == 0}stickan
					{:else}stickan
					{/if}
	</button>

			<button
						class="{view === 2 ? 'selected' : ''}"
						on:click={() => view = 2}>
						{#if $language == 0}kontakt
						{:else}contact
						{/if}
		</button>
	</div>

</div>

<style>


	.selected{
		border-bottom: 1px solid red;
	}

	h1{
		margin-left: 100px;
		margin-top: 10px;
		width: 300px;
		font-family: 'Flightcase Regular','FlightcaseTwo', Serif;
	}
	#textblock{
		height: 100px;
		width:100%;
	}
	#logoblock{
		float: left;
  	width: 15%;
		height: 100px;
		width: 300px;
	}
	#listblock{
		float: right;
  	width: 50%;
		margin-top: 10px;
		margin-right:10px;
		text-align: right;
		}

	button{
		font-family: Abril Fatface;
		font-size: 13px;
		border: none;
    background-color: transparent;
    outline: none;
		cursor: pointer;
		margin-right:30px;

	</style>
